import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class EventMappingLookup extends ModelBase {

    public genericEventMappingID: number = 0;

    public stockBroker: string = "";

    public staticEventID: number | null = null;

    public staticEventName: string = "";

    public securityOrCash: string = "";

    public fileType: number = 0;

    public eventType: string = "";

    public corporateActionType: string = "";

    public adhocBookingType: string = "";

    public buyOrSell: string = "";

    public isPositiveValue: boolean = false;

    public selected: boolean = false;
}